import { createTheme } from '@mui/material/styles'

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    plain: true
  }
}

declare module '@mui/material/styles' {
  interface Palette {
    backgroundMain: string
  }
  interface PaletteOptions {
    backgroundMain: string
  }
}

const theme = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      light: '#bcdda3',
      main: '#047857',
    },
    secondary: {
      main: '#F37420',
      light: '#FBB664',
    },
    backgroundMain: '#059669'
  },
  typography: {
    fontFamily: ['"brandon-grotesque"', 'Sans-serif'].join(','),
    h3: { fontSize: '2.75rem' },
  },
  components: {
    MuiPaginationItem: {
      styleOverrides: {
        textPrimary: {
          '&:hover': {
            color: '#000',
          },
          '&:focus': {
            outline: 'none',
            color: '#000',
            backgroundColor: '#FFF',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({
          ownerState,
        }: {
          ownerState: { variant?: string; color?: string }
        }) => ({
          textTransform: 'none' as const,
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'primary' && {
              color: '#fff',
              '&:focus': {
                color: '#fff',
                backgroundColor: '#44b97f',
              },
            }),
          ...(ownerState.variant === 'outlined' &&
            ownerState.color === 'primary' && {
              '&:focus': {
                color: '#44b97f',
                backgroundColor: '#fff',
              },
            }),
          ...(ownerState.variant === 'plain' &&
            ownerState.color === 'primary' && {
              backgroundColor: '#44b97f',
              color: '#fff',
              '&:focus,:hover': {
                backgroundColor: '#44b97f',
                color: '#fff',
                filter: 'brightness(0.9)',
              },
            }),
        }),
      },
    },
  },
}

export default createTheme(theme)
